import {
    TableCell,
    TableRow,
    Stack,
    Typography,
    ButtonGroup,
    IconButton,
    Menu,
    MenuItem,
    Divider,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import ToolTipCustomTakeDevice from './modal/ToolTipCustomTakeDevice';
import Iconify from 'src/components/iconify';
import { useTranslation } from 'react-i18next';
import { FormatNumber, glb_sv } from 'src/utils';
import Label from 'src/components/label';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

const ItemListTakeDevice = ({
    item,
    index,
    STATUS_COLOR,
    isAdmin,
    dataRef,
    setVisibleApprove,
    setVisibleReject,
    setVisible,
    setVisibleRefund,
    setVisibleRequestFixDevice,
    setVisibleConfirmFixDevice,
    openButton,
    setOpenChangeRequestDevice,
    setOpenTakeDevice,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const anchorTabEdit = useRef(null);
    const user = glb_sv.userInfo;
    const isUserAprove = user?.group_user === '4';
    return (
        <TableRow hover key={index} tabIndex={-1} role="checkbox">
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox">{index + 1}</TableCell>
            <TableCell
                align="left"
                onClick={(e) => {
                    if (['5', '6'].includes(item.status)) {
                        setAnchorEl(e.currentTarget);
                    }
                }}
            >
                <Label color={STATUS_COLOR[item.status]}>{item.status_content}</Label>
            </TableCell>

            <TableCell
                align="left"
                style={{ minWidth: '250px' }}
                onClick={(e) => {
                    if (['5', '6'].includes(item.status)) {
                        setAnchorEl(e.currentTarget);
                    }
                }}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    {openButton && (
                        <img
                            style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '5px',
                                backgroundColor: '#999',
                            }}
                            src={`${glb_sv.urlGetProductImage(item?.img_device || item?.pic_device)}`}
                            alt=""
                        />
                    )}
                    <Typography variant="subtitle2">{glb_sv.convertMultipleLanguages(item.device_nm)}</Typography>
                </Stack>
            </TableCell>
            {/* <TableCell align="left">{item.device_cd}</TableCell> */}
            <TableCell align="left">
                <Stack display={'flex'} flexDirection={'column'}>
                    <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                        {t('cabinet')}: {item.cabinet_nm}
                    </Typography>
                    <Typography variant="subtitle3" noWrap>
                        {t('drawer')}: {item.drawer_nm}
                    </Typography>{' '}
                    <Typography variant="subtitle3" noWrap>
                        {t('cell')}: {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                    </Typography>
                </Stack>
            </TableCell>

            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.user_nm}
                </Typography>
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.user_assign_nm}
                </Typography>
            </TableCell>
            <TableCell>{item.transaction_dt && glb_sv.formatDate(item.transaction_dt, 'YYYYMMDDHHmmss')}</TableCell>
            <TableCell align="right" sx={{ fontWeight: '600' }}>
                {item.qty} Pcs
            </TableCell>
            <TableCell align="right">
                <Typography variant="subtitle2">{item.qty_change_request} Pcs</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography
                    variant="subtitle2"
                    color={item.cell_qty + item.qty < item.qty_change_request ? 'error' : 'primary'}
                >
                    {item.cell_qty} Pcs
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="subtitle2">{item.note_change}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.request_user_nm}
                </Typography>
            </TableCell>
            <TableCell align="left">
                {item.request_date && glb_sv.formatDate(item.request_date, 'YYYYMMDDHHmmss')}
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {['5', '6', '7'].includes(item.status) ? item?.user_approve_grindding_nm : item.user_approve_nm}
                </Typography>
            </TableCell>
            <TableCell align="left">
                {['5', '6', '7'].includes(item.status)
                    ? item.approve_grindding_or_reject_date &&
                      glb_sv.formatDate(item.approve_grindding_or_reject_date, 'YYYYMMDDHHmmss')
                    : item.approve_or_reject_date && glb_sv.formatDate(item.approve_or_reject_date, 'YYYYMMDDHHmmss')}
            </TableCell>
            <TableCell align="left">{item.reason}</TableCell>
            <TableCell align="left">{item.note_repair_device}</TableCell>
            <TableCell align="left">
                {parseInt(item.status) >= 5 && parseInt(item.status) < 8 && (
                    <Stack display={'flex'} flexDirection={'column'}>
                        <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                            {t('cabinet')}: {item.cabinet_request_name}
                        </Typography>{' '}
                        <Typography variant="subtitle3" noWrap>
                            {t('drawer')}: {item.drawer_request_name}
                        </Typography>{' '}
                        <Typography variant="subtitle3" noWrap>
                            {t('cell')}:{' '}
                            {`[ ${item?.cell_request_cell_lc?.row} : ${item?.cell_request_cell_lc?.column} ]`}
                        </Typography>
                    </Stack>
                )}
            </TableCell>
            <TableCell align="left">
                {parseInt(item.status) >= 6 &&
                    parseInt(item.status) < 8 &&
                    item.date_repairing &&
                    glb_sv.formatDate(item.date_repairing, 'YYYYMMDDHHmmss')}
            </TableCell>
            <TableCell align="left">
                {parseInt(item.status) >= 5 && parseInt(item.status) < 8 && FormatNumber(item.price_repair_sharpen)}
            </TableCell>
            <TableCell align="left">{item.note}</TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.device_cd}
                </Typography>
            </TableCell>
            {openButton && (
                <TableCell
                    padding="checkbox"
                    sx={{
                        position: 'sticky',
                        right: 0,
                        backgroundColor: 'white',
                        zIndex: 3,
                        backgroundColor: '#f4f6f8',
                    }}
                    ref={anchorTabEdit}
                >
                    <IconButton
                        size="large"
                        // color={'success'}
                        onClick={() => {
                            setOpenEdit(true);
                        }}
                    >
                        <MoreHorizIcon />
                    </IconButton>

                    <Menu
                        anchorEl={anchorTabEdit.current}
                        open={openEdit}
                        onClose={() => setOpenEdit(false)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        {/* <ButtonGroup
                            variant="text"
                            aria-label="text button group"
                            style={{ display: 'flex', justifyContent: 'space-between' }}
                        > */}
                        {(isAdmin || isUserAprove) && (
                            <>
                                <MenuItem
                                    size="large"
                                    onClick={() => {
                                        dataRef.current = item;
                                        setVisibleApprove(true);
                                    }}
                                    disabled={!(item.status === '1' || item.status === '2')}
                                >
                                    <IconButton
                                        color={'success'}
                                        disableRipple
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                        }}
                                        disabled={!(item.status === '1' || item.status === '2')}
                                    >
                                        <Iconify color={'success'} icon={'line-md:check-all'} />{' '}
                                        <Typography style={{ marginLeft: 10 }}>{t('comfirm')}</Typography>
                                    </IconButton>
                                </MenuItem>
                                <Divider sx={{ my: 0.5 }} />
                                <MenuItem
                                    size="large"
                                    onClick={() => {
                                        dataRef.current = item;
                                        setVisibleReject(true);
                                    }}
                                    disabled={!(item.status === '1' || item.status === '2')}
                                >
                                    <IconButton
                                        disabled={!(item.status === '1' || item.status === '2')}
                                        color={'error'}
                                        disableRipple
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <Iconify icon={'mdi:cancel'} />
                                        <Typography style={{ marginLeft: 10 }}>{t('reject')}</Typography>
                                    </IconButton>
                                </MenuItem>
                                <Divider sx={{ my: 0.5 }} />
                            </>
                        )}

                        <MenuItem
                            size="large"
                            disabled={
                                !['0'].includes(item.status) ||
                                !(item.user_id === user.id || isAdmin) ||
                                isUserAprove ||
                                item?.qty_have_return >= item?.qty
                            }
                            onClick={() => {
                                dataRef.current = item;
                                setVisible(true);
                            }}
                        >
                            <IconButton
                                disabled={
                                    !['0'].includes(item.status) ||
                                    !(item.user_id === user.id || isAdmin) ||
                                    isUserAprove ||
                                    item?.qty_have_return >= item?.qty
                                }
                                color={'primary'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Iconify icon={'mdi:pencil'} />{' '}
                                <Typography style={{ marginLeft: 10 }}>{t('edit')}</Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            size="large"
                            onClick={() => {
                                dataRef.current = item;
                                setVisibleRefund(true);
                            }}
                            disabled={
                                !['0', '6'].includes(item.status) ||
                                !(item.user_id === user.id || isAdmin) ||
                                isUserAprove ||
                                item?.qty_have_return >= item?.qty
                            }
                        >
                            <IconButton
                                disabled={
                                    !['0', '6'].includes(item.status) ||
                                    !(item.user_id === user.id || isAdmin) ||
                                    isUserAprove ||
                                    item?.qty_have_return >= item?.qty
                                }
                                color={'warning'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Iconify icon={'mdi:restore'} />{' '}
                                <Typography style={{ marginLeft: 10 }}>{t('requestRefund')}</Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            size="large"
                            disabled={
                                !['0', '13', '12', '5'].includes(item.status) ||
                                item.can_grindding === '0' ||
                                (item.status !== '5' && !isAdmin && item.user_id !== user.id) ||
                                isUserAprove ||
                                item?.qty_have_return >= item?.qty
                            }
                            onClick={() => {
                                dataRef.current = item;
                                setVisibleRequestFixDevice(true);
                            }}
                        >
                            <IconButton
                                disabled={
                                    !['0', '13', '12', '5'].includes(item.status) ||
                                    item.can_grindding === '0' ||
                                    (item.status !== '5' && !isAdmin && item.user_id !== user.id) ||
                                    isUserAprove ||
                                    item?.qty_have_return >= item?.qty
                                }
                                color={'primary'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Iconify icon={'mdi:build'} />{' '}
                                <Typography style={{ marginLeft: 10 }}>{t('request_grinding_device')}</Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            size="large"
                            onClick={() => {
                                dataRef.current = item;
                                setOpenChangeRequestDevice(true);
                            }}
                            disabled={
                                !['0', '13', '12'].includes(item.status) ||
                                !(item.user_id === user.id || isAdmin) ||
                                isUserAprove ||
                                item?.qty_have_return >= item?.qty
                            }
                        >
                            <IconButton
                                color={'info'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                                disabled={
                                    !['0', '13', '12'].includes(item.status) ||
                                    !(item.user_id === user.id || isAdmin) ||
                                    isUserAprove ||
                                    item?.qty_have_return >= item?.qty
                                }
                            >
                                <Iconify color={'info'} icon={'mdi:package-variant'} />{' '}
                                <Typography style={{ marginLeft: 10 }}>{t('request_change_device')}</Typography>
                            </IconButton>
                        </MenuItem>

                        {item.status === '11' && (
                            <>
                                <Divider sx={{ my: 0.5 }} />
                                <MenuItem
                                    size="large"
                                    onClick={() => {
                                        dataRef.current = item.id;
                                        setOpenTakeDevice(true);
                                    }}
                                    disabled={!(item.user_id === user.id || isAdmin) || isUserAprove}
                                >
                                    <IconButton
                                        color={'info'}
                                        disableRipple
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                        }}
                                        disabled={!(item.user_id === user.id || isAdmin) || isUserAprove}
                                    >
                                        <Iconify color={'info'} icon={'mdi:package-variant'} />{' '}
                                        <Typography style={{ marginLeft: 10 }}>{t('take_device')}</Typography>
                                    </IconButton>
                                </MenuItem>
                            </>
                        )}

                        {isAdmin && (
                            <>
                                <Divider sx={{ my: 0.5 }} />
                                <MenuItem
                                    size="large"
                                    disabled={
                                        item.status !== '7' ||
                                        item.can_grindding === '0' ||
                                        item.user_approve_grindding_id !== user.id ||
                                        isUserAprove
                                    }
                                    onClick={() => {
                                        dataRef.current = item;
                                        setVisibleConfirmFixDevice(true);
                                    }}
                                >
                                    <IconButton
                                        disabled={
                                            item.status !== '7' ||
                                            item.can_grindding === '0' ||
                                            item.user_approve_grindding_id !== user.id ||
                                            isUserAprove
                                        }
                                        color={'primary'}
                                        disableRipple
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <Iconify icon={'mdi:wrench-check'} />{' '}
                                        <Typography style={{ marginLeft: 10 }}>
                                            {t('confirm_grindding_success')}
                                        </Typography>
                                    </IconButton>
                                </MenuItem>
                            </>
                        )}
                        {/* </ButtonGroup> */}
                    </Menu>
                </TableCell>
            )}
            {/* <TableCell padding="checkbox"></TableCell> */}
            <ToolTipCustomTakeDevice open={anchorEl} handleClose={() => setAnchorEl(null)} item={item} />
        </TableRow>
    );
};

export default ItemListTakeDevice;
